module.exports = __webpack_public_path__ + "img/img4.356b016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img4.png
// module id = 228
// module chunks = 0